import { inject } from '@angular/core';
import {
  HttpEvent,
  HttpRequest,
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

// Importaciones de entornos.
import { environment } from '../../environments/environment';

// Importaciones de servicios.
import { AuthService } from '../services/auth.service';

/**
 * Interceptor de errores HTTP.
 * Este interceptor captura las respuestas HTTP que contienen errores y las maneja
 * de manera adecuada. Si la respuesta del servidor contiene un array de errores,
 * se procesan y se extraen los mensajes de error. Si no se recibe una respuesta
 * estructurada desde el servidor, se muestra un mensaje de error genérico.
 * En entornos que no son de producción, también se registra el error completo en
 * la consola para facilitar la depuración.
 *
 * @param req - La solicitud HTTP que se está realizando.
 * @param handler - Función que envía la solicitud al siguiente manejador.
 *
 * @returns Observable que puede devolver eventos HTTP o lanzar un error procesado.
 */
export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  handler: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return handler(req).pipe(
    catchError((httpErrorResponse: HttpErrorResponse) => {
      const errors: string[] = [];

      if (
        httpErrorResponse.error?.errors &&
        Array.isArray(httpErrorResponse.error.errors)
      ) {
        errors.push(...httpErrorResponse.error.errors);
      } else {
        errors.push(
          'Ha ocurrido un error inesperado, por favor, inténtelo de nuevo más tarde.'
        );
      }

      if (!environment.production) {
        console.error(httpErrorResponse);
      }

      // Si el error es un 401 (no autorizado), se limpia el token y se redirige a login.
      if (httpErrorResponse.status === 401) {
        authService.removeToken();
        router.navigateByUrl('/login');
      }

      return throwError(() => errors);
    })
  );
};
